<template>
  <div class="study-particip-details-block" :class="{ 'telehealth-call': telehealthCallStatus }">
    <div class="nav-breadcrumb pt-10 pl-4">
      <NavigationBreadcrumb :navigationWidth="navigationWidth" :navigationOptions="navigationOptions" @toggleParticipant="toggleParticipant"></NavigationBreadcrumb>
    </div>
    <div class="clear-float"></div>
    <PiiAndNonPiiInfo class="clear-both" v-if="participantInfo" :participantDetails="participantInfo" :studyData="studyData" @expanded="piInfoExpanded" :studyResponse="studyResponse" :isDataLoadingFinishFlag="true" @updateFlagPID="changePrtID"></PiiAndNonPiiInfo>
    <b-row class="mt-6" id="edcFromDetail">
      <b-col cols="12" class="p-0 forms-action-button">
        <ParticipantInfo :participantDetails="participantInfo" :areActionsAllowed="areActionsAllowed" />
      </b-col>
      <b-col cols="6" class="edc-wrap pl-0 pr-0 mt-45" v-if="displayMobileView === false">
        <div class="primaryBackGround fs-12">
          <b-row>
            <b-col cols="10">
              <label>
                <b>Select an unscheduled packet</b>
              </label>
              <b-form-select class="fs-12" size="md" v-model="packetSelected">
                <option :value="null">Select Unscheduled Packet</option>
                <option v-for="(packet, index) in unscheduledPackets.filter(unscheduledPacket => unscheduledPacket.milestonesList && unscheduledPacket.milestonesList.length == 0)" v-bind:value="packet.id" :key="index">{{ packet.name }}</option>
              </b-form-select>
            </b-col>
          </b-row>
          <b-row class="pt-20 pb-10">
            <b-col class="pr-0 col-sm-3 col-lg-2" cols="1">
              <b-btn size="sm" class="cancel_btn" @click="goToParticipantDetails"><span class="cancel_text">Cancel</span></b-btn>
            </b-col>
            <b-col class="pr-0 col-sm-3 col-lg-2" cols="1">
              <b-btn size="sm" class="Continue_btn" @click="goToUnscheduledPacketPiView" :disabled="!packetSelected || !packetSelected.length"><span class="continue-text pt-5">Continue</span></b-btn>
            </b-col>
          </b-row>
        </div>
      </b-col>
      <b-col cols="12" class="edc-wrap pl-0 pr-0 mt-45" v-if="displayMobileView === true">
        <div class="primaryBackGround fs-12">
          <b-row>
            <b-col cols="11" class="p-0 col-sm-7 pb-3 ipad_cancle_btn">
              <label class="pb-5">
                <b>Select an unscheduled packet</b>
              </label>
              <b-form-select class="fs-12" size="md" v-model="packetSelected">
                <option :value="null">Select Unscheduled Packet</option>
                <option v-for="(packet, index) in unscheduledPackets.filter(unscheduledPacket => unscheduledPacket.milestonesList && unscheduledPacket.milestonesList.length == 0)" v-bind:value="packet.id" :key="index">{{ packet.name }}</option>
              </b-form-select>
            </b-col>
          </b-row>
          <b-row class="pt-20 pb-10">
            <b-col class="pl-0 offset-sm-1 col-sm-3 col-lg-2 ipad_cancle_btn" cols="3">
              <b-btn size="md" class="cancel_btn" @click="goToParticipantDetails"><span class="cancel_text">Cancel</span></b-btn>
            </b-col>
            <b-col class="p-0 col-sm-3 col-lg-2" cols="3">
              <b-btn size="md" class="Continue_btn" @click="goToUnscheduledPacketPiView" :disabled="!packetSelected || !packetSelected.length"><span class="continue-text pt-5">Continue</span></b-btn>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import find from "lodash/find";
import PiiAndNonPiiInfo from "@/components/participants/pii-and-non-pii-info";
import NavigationBreadcrumb from "@/components/common/navigation-breadcrumb";
import ParticipantInfo from "@/components/participants/participant-info-new";
import { mapGetters } from "vuex";
import sortBy from "lodash/sortBy";
import * as constant from "@/constants/config";
export default {
  name: "Form-view",
  data() {
    return {
      unscheduledForms: [],
      studyId: this.$route.params.studyId,
      participantId: this.$route.params.participantId,
      responseType: this.$route.params.responseType,
      participantInfo: {},
      unscheduledPackets: [],
      packetSelected: null,
      formSelected: null,
      navigationOptions: [
        {
          name: "Profile",
          isLink: true,
          route: "participant-profile",
          params: { studyId: this.$route.params.studyId },
          displayOrder: 2
        },
        {
          name: "Participants",
          isLink: true,
          route: "study-participants-list",
          params: { studyId: this.$route.params.studyId },
          displayOrder: 1
        },
        {
          name: "Packet",
          isLink: false,
          route: null,
          params: null,
          displayOrder: 3
        }
      ],
      areActionsAllowed: {
        document: false,
        telehealth: true,
        edcforms: false,
        approval: false,
        verifyBtn: false,
        send: false,
        sign: false,
        print: false
      },
      navigationWidth: "66%",
      telehealthCallStatus: false,
      displayMobileView: Boolean,
      studyResponse: {}
    };
  },
  components: {
    PiiAndNonPiiInfo,
    NavigationBreadcrumb,
    ParticipantInfo
  },
  created() {
    if (constant.SCREENWIDTH > 1200) {
      this.displayMobileView = false;
    } else {
      this.displayMobileView = true;
    }
  },
  methods: {
    getSortedforms(unscheduledForms) {
      return sortBy(unscheduledForms, [
        function(o) {
          return o.formName.toLowerCase().trim();
        }
      ]);
    },
    // get the participant details
    piInfoExpanded(isExpanded) {
      const c = document.getElementById("edcFromDetail");
      if (isExpanded) {
        setTimeout(() => {
          window.$("#edcFromDetail").animate({});
        }, 400);
      } else {
        c.style.paddingTop = "0px";
      }
    },
    getParticipantInfo() {
      this.$api.getParticipantDataFactV2(this.studyId, this.$route.params.participantId).then(
        response => {
          this.participantInfo = response.body;
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting participant.");
        }
      );
    },
    sortArrayOfObject(arrObject) {
      arrObject.sort((a, b) => {
        const strA = a.name.toUpperCase();
        const strB = b.name.toUpperCase();
        return strA < strB ? -1 : strA > strB ? 1 : 0;
      });
      return arrObject;
    },
    // get the unscheduled packets details
    getEDCUnscheduledPackets() {
      this.$api
        .getUnscheduledPacketNewFactV3(this.studyId)
        .then(response => {
          this.unscheduledPackets = response.body.filter(result => result.activitySchedulingMode == "unschedule");
          this.unscheduledPackets = this.sortArrayOfObject(this.unscheduledPackets);
        })
        .catch(error => {
          if (error && (error.message || error.body.message)) {
            this.$toastr.error(error.message || error.body.message);
          } else {
            this.$toastr.error("Unable to fetch the unscheduled packets");
          }
        });
    },

    // goto participant details page
    goToParticipantDetails() {
      this.$router.push({
        name: "participant-profile",
        params: { studyId: this.studyId, participantId: this.participantId }
      });
    },

    // goto unscheduled packet forms page
    goToUnscheduledPacketPiView() {
      if (find(this.unscheduledPackets, ["id", this.packetSelected]).unscheduledForms.length) {
        this.$router.push({
          name: "study-participant-edc-unschedule-packet-reskin",
          params: {
            studyId: this.studyId,
            participantId: this.participantId,
            packetId: this.packetSelected,
            unscheduledPacketResponseId: "0",
            responseType: this.responseType
          }
        });
      } else {
        this.$toastr.warning("There are no forms available in the selected packet.");
      }
    },
    toggleParticipant(participant) {
      this.$router.push({
        name: "study-participant-edc-unschedule-packets-reskin",
        params: { studyId: this.studyId, participantId: participant.id }
      });
      this.participantId = participant.id;
      this.getParticipantInfo();
    },
    getEDCFormDetails() {
      this.$api.getEDCFormsFact(this.studyId).then(response => {
        this.unscheduledForms = response.body;
      });
    },
    goToUnscheduledFormPiView() {
      if (find(this.unscheduledForms, ["formId", this.formSelected]).formId.length) {
        this.$router.push({
          name: "study-participant-edc-reskin",
          params: {
            studyId: this.studyId,
            participantId: this.participantId,
            formId: this.formSelected,
            milestone: this.unscheduledForms.milestone || "0",
            responseId: this.unscheduledForms.responseId || "0"
          }
        });
      }
    },
    getStudyResponseDetails() {
      this.studyResponse = JSON.parse(window.localStorage.getItem("studyDetailsData"));
    },
    changePrtID(dataObj) {
      this.participantInfo.userDefinedParticipantId = dataObj.newUserDefinedParticipantId;
      this.getParticipantInfo();
    }
  },
  mounted() {
    this.getParticipantInfo();
    this.getEDCUnscheduledPackets();
    this.getEDCFormDetails();
    this.getStudyResponseDetails();
  },
  props: ["studyData"],
  computed: {
    ...mapGetters(["getVideoCallStatus"])
  },
  watch: {
    getVideoCallStatus(isCallInProgress) {
      this.telehealthCallStatus = isCallInProgress;
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/assets/variables.scss";
.study-particip-details-block {
  background-color: #ffffff !important;
  .participant-detail-section {
    background-color: #fff;
  }
}
.edc-wrap {
  height: 630px;
  label {
    font-size: 14px;
    color: #4a4a4a;
  }
}
.btn-block {
  border: solid 1px #e4e8eb;
  padding: 11px;
  font-size: 14px;
  border-radius: 4px;
  &.cancel {
    color: #4a4a4a;
  }
}
.custom-select {
  background-image: url(/static/img/icon-2-down.png) !important ;
}
.Continue_btn {
  width: 115px;
  height: 38.7px;
  margin: 0 0px 5.4px 0;
  border-radius: 4px;
  border: solid 1px #0062cc;
  background-color: #0062cc;
}
.continue-text {
  font-size: 14px;
  font-weight: bold;
  color: #ffffff;
}
.cancel_btn {
  width: 101px;
  height: 40px;
  border-radius: 4px;
  border: solid 1px #e4e8eb;
  background-color: #ffffff;
}
.cancel_text {
  font-size: 14px;
  color: #4a4a4a;
}
@media (max-width: 1000px) {
  .cancel_btn {
    width: 100%;
  }
  .Continue_btn {
    width: 100%;
    position: relative;
    left: 58px;
  }
}
@media (min-width: 1000px) and (max-width: 1270px) {
  .cancel_btn {
    width: 100%;
  }
  .Continue_btn {
    width: 100%;
    position: relative;
    left: 42px;
  }
}
@media (min-width: 1270px) and (max-width: 1500px) {
  .Continue_btn {
    position: relative;
    left: 22px;
  }
}
@media screen and (min-width: 320px) and (max-width: 768px) {
  .cancel_btn {
    width: 100%;
  }
  .Continue_btn {
    width: 100%;
    position: relative;
    left: auto;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1111px) {
  .ipad_cancle_btn {
    margin-left: 6%;
  }
}
</style>
